import { LEGAL_DOCUMENTS } from './legalLinks.js';

// The signed-out screens' legal footer: a discreet pair of outward links under
// the form. The mobile app shows these two documents on its sign-up screen, which
// web does not have, so without this the only unauthenticated way to reach them
// would be to know the URL.
//
// They link straight out (a new tab, as everywhere else on the web client) rather
// than to the /legal screen: reading the terms should not navigate a half-filled
// login form away. Same outward-link contract as ActionPanel — new tab, no
// window.opener, and said so for assistive tech.
export default function LegalFooter() {
  return (
    <nav className="legal-footer" aria-label="Legal">
      {LEGAL_DOCUMENTS.map(({ title, href }) => (
        <a key={href} href={href} target="_blank" rel="noopener noreferrer">
          {title}
          <span className="visually-hidden"> (opens in a new tab)</span>
        </a>
      ))}
    </nav>
  );
}
